import { Chip } from '@mui/material';
import { formatFileImportLabel } from './fileImportFormatters';

const STATUS_COLORS = {
  pending: 'default',
  processing: 'info',
  parse_failed: 'error',
  processing_failed: 'error',
  processed_successfully: 'success',
  processed_with_errors: 'warning',
  sent: 'success',
  failed: 'error',
  moved: 'success',
  not_required: 'default',
  successful: 'success',
  unchanged: 'default',
};

const FileImportStatusChip = ({ value }) => (
  <Chip
    size='small'
    label={formatFileImportLabel(value)}
    color={STATUS_COLORS[value] || 'default'}
    variant={value ? 'filled' : 'outlined'}
  />
);

export default FileImportStatusChip;
